export const DATE_PLACEHOLDER = 'DDMMYYYY';
